import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Spinner from '@narvar/nth-spinner';
import { CTAButton, FormIntroWrapper } from './styles';

const mapStateToProps = ({ language, retailerSettings: { branding } }) => ({
  language,
  branding,
});

export const FormIntroComponent = ({ onClick, language, branding, loading }) => {
  if (loading) {
    return (
      <FormIntroWrapper>
        <Spinner />
      </FormIntroWrapper>
    );
  }

  return (
    <FormIntroWrapper>
      {language['returns.items.multi_item_form.user_query']}{' '}
      <CTAButton branding={branding} onClick={onClick}>
        {language['returns.items.multi_item_form.enable_link']}
      </CTAButton>
    </FormIntroWrapper>
  );
};

export const FormIntro = connect(mapStateToProps)(FormIntroComponent);

FormIntroComponent.propTypes = {
  onClick: PropTypes.func.isRequired,
  language: PropTypes.object.isRequired,
  branding: PropTypes.object.isRequired,
  loading: PropTypes.bool,
};

FormIntroComponent.defaultProps = {
  loading: false,
};
